import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import {  FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-banner-card',
  imports: [RouterModule, CommonModule, FontAwesomeModule],
  templateUrl: './banner-card.component.html',
  styleUrl: './banner-card.component.scss'
})
export class BannerCardComponent {

  @Input() title:string="";
  @Input() image:string="";
  @Input() class:string="pt-3 bg-white";
  @Input() css:string="";
  @Input() id:string="";
  @Input() description:string="";
  @Input() url:string="";
  @Input() actionText:string="";
  @Input() link:string|null = null;
  @Input() fragment:string|null = null;
  @Input() customBody:boolean= false;
  faArrowRight=faPlay;
  
  constructor(private router:Router, @Inject(DOCUMENT) private document: Document, @Inject(PLATFORM_ID) private platformId: Object){}
  navigate(){
    if(this.link && this.fragment){
      console.log("LF",this.link,this.fragment)
      this.router.navigate([this.link],{fragment:this.fragment})
     }
     else if(this.link){
      console.log("L",this.link)
       this.router.navigateByUrl(this.link);
     }    
     else if(this.url){
      //console.log("URL",this.url)
       if (isPlatformBrowser(this.platformId)) {  
        window!.open(this.url, '_blank')?.focus();
       //document.location =this.url;
       //this.document.open(this.url, '_blank');
       }
     }
  }
}
